import React, {PureComponent} from "react"
import Button from "@irati/ui/src/Button"
import Loading from "@irati/ui/src/Loading"
import Form from "@irati/ui/src/Form"
import {ValidationButton} from "@irati/ui/src/FormItem"
import {Label2, Strong} from "@irati/ui/src/Labels"
import mfaService from "@irati/auth/services/mfa"
import {MFAPhoneNumber} from "@irati-web/fields/mfa"
import FormattedMessage from "@irati/utils/lang"
import {mfaTracking} from "@irati-tracking/platform"
import {validatedScreen} from "@irati/utils/validation"
import {Modal} from "../BaseModal"
import {Screens, selectScreen} from "./index"
import {ButtonContainer} from "./styled"

interface Props {
  selectScreen: selectScreen,
  onCancel(): void,
  show: boolean
}

interface State {
  phoneNumber: string,
  submit: Promise<any> | null
}

class MFAPopupSetup extends PureComponent<Props, State> {
  state: State = {
    phoneNumber: "",
    submit: null
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.show === false && this.props.show === true) {
      mfaTracking.popupSetupShown()
    }
  }

  handleSuccess = () => {
    const submit = mfaService.setup(this.state.phoneNumber).then((mfa) => {
      const phoneNumber = mfa.phoneNumberLastDigits
      this.props.selectScreen(Screens.ENTER, {phoneNumber})
      mfaTracking.popupSetupComplete()
    })
    this.setState({submit})
  }

  handleChange = (phoneNumber: string) => this.setState({phoneNumber})

  handleCancel = () => {
    this.props.onCancel()
    mfaTracking.popupSetupCancel()
  }

  render() {
    return (
      <Modal show={this.props.show} header="platform.mfa.setup.title">
        <Label2 block small>
          <FormattedMessage
            id="platform.mfa.setup.bodyWithBoldText"
            values={{boldText: <Strong>
              <FormattedMessage id="platform.mfa.setup.boldText" />
            </Strong>}} />
        </Label2>
        <Form>
          <MFAPhoneNumber value={this.state.phoneNumber} onChange={this.handleChange} />
          <Loading load={this.state.submit} useLoader={false} />
          <ButtonContainer>
            <Button onClick={this.handleCancel}>
              <FormattedMessage id="platform.mfa.setup.cancel" />
            </Button>
            <ValidationButton onClick={this.handleSuccess} primary load={this.state.submit}>
              <FormattedMessage id="platform.mfa.setup.submit" />
            </ValidationButton>
          </ButtonContainer>
        </Form>
      </Modal>
    )
  }
}

export default validatedScreen(MFAPopupSetup, "MFAPopup")
